var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10, _rect, _ellipse2, _path11, _path12, _ellipse3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25522 69.3023C-1.40019 116.715 34.9309 136 64.9532 136C94.9756 136 134 110.391 134 83.1164C134 55.8416 134.069 39.3968 103.869 28.8794C73.6688 18.3621 5.91064 21.8895 2.25522 69.3023Z",
    fill: "#F9F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.808 59.25L68 76.025V44L102.808 59.25Z",
    fill: "#7B79DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.808 100.425V59.25L68 76.025V117.2L102.808 100.425Z",
    fill: "#B1B0F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1916 100.425V59.25L68 76.025V117.2L33.1916 100.425Z",
    fill: "#8E8CEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1916 59.25L68 76.025V44L33.1916 59.25Z",
    fill: "#B1B0F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4893 74.5L33.1914 59.25L67.9997 76.025L59.2976 92.8L24.4893 74.5Z",
    fill: "#7B79DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.51 74.5L102.808 59.25L67.9993 76.025L76.7014 92.8L111.51 74.5Z",
    fill: "#E6E5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.021 25.9299C110.383 26.7964 109.973 27.7919 109.107 28.1533C103.739 30.392 98.9358 35.4204 95.1637 41.8222C91.4076 48.197 88.7845 55.7515 87.6794 62.7552C87.5331 63.6826 86.6627 64.3158 85.7353 64.1695C84.8078 64.0232 84.1747 63.1527 84.321 62.2253C85.4901 54.8157 88.2531 46.8531 92.2344 40.0962C96.1998 33.3662 101.485 27.6484 107.798 25.0153C108.664 24.6539 109.66 25.0634 110.021 25.9299Z",
    fill: "#B1B0F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8856 14.9226C64.5167 15.6177 64.4647 16.6929 63.7696 17.3239C62.7543 18.2457 62.5589 19.4227 63.0636 20.9704C63.5917 22.5896 64.839 24.3431 66.2794 25.782C68.388 27.8882 69.3241 30.2392 68.8671 32.9441C68.4427 35.4558 66.8464 38.0331 64.6007 40.8096C62.6632 43.2051 62.2716 45.4003 62.6765 47.2569C63.0949 49.1752 64.4241 50.9992 66.4131 52.4431C67.1729 52.9946 67.3417 54.0577 66.7901 54.8175C66.2386 55.5773 65.1755 55.7461 64.4157 55.1945C61.9487 53.4037 59.9967 50.9253 59.3546 47.9814C58.6991 44.9759 59.4677 41.7493 61.9572 38.6714C64.1384 35.9745 65.2447 33.9749 65.5146 32.3776C65.7518 30.9734 65.374 29.6832 63.8766 28.1875C62.225 26.5377 60.586 24.3392 59.8312 22.0246C59.053 19.6386 59.1781 16.9002 61.4842 14.8066C62.1793 14.1755 63.2545 14.2274 63.8856 14.9226Z",
    fill: "#8E8CEE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117,
    cy: 23,
    rx: 3,
    ry: 3,
    fill: "#8E8CEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6065 5.02173L99.4443 10.609C99.4666 10.6767 99.5233 10.7275 99.5931 10.7422L105.349 11.9541L99.591 10.7522C99.5212 10.7376 99.4489 10.7613 99.4013 10.8144L95.4739 15.1929L99.3937 10.8076C99.4412 10.7544 99.4568 10.68 99.4347 10.6122L97.6065 5.02173Z",
    fill: "#8E8CEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 27.0894,
    width: 8,
    height: 8,
    rx: 1,
    transform: "rotate(-22.7167 82 27.0894)",
    fill: "#8E8CEE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 33,
    rx: 3,
    ry: 3,
    fill: "#8E8CEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8637 35.8395C29.5212 36.7136 29.9521 37.7 30.8263 38.0425C33.7663 39.1946 37.1944 41.8651 40.4251 45.458C43.633 49.0254 46.5249 53.3677 48.4461 57.6904C48.8274 58.5484 49.832 58.9348 50.69 58.5535C51.548 58.1722 51.9344 57.1675 51.553 56.3096C49.4742 51.6323 46.3779 46.993 42.9534 43.1846C39.5517 39.4016 35.7033 36.3019 32.0668 34.8769C31.1926 34.5343 30.2063 34.9653 29.8637 35.8395Z",
    fill: "#8E8CEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6797 11.9539L35.6174 17.4622C35.5923 17.529 35.6048 17.6041 35.65 17.6592L39.3813 22.2059L35.6422 17.6657C35.5968 17.6106 35.5256 17.5839 35.4552 17.5955L29.652 18.5535L35.4535 17.5854C35.5239 17.5737 35.5827 17.5254 35.6078 17.4586L37.6797 11.9539Z",
    fill: "#8E8CEE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.2014,
    cy: 6.23436,
    rx: 3,
    ry: 3,
    transform: "rotate(-12.6516 69.2014 6.23436)",
    fill: "#8E8CEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 33,
    r: 3,
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBox);
export default __webpack_public_path__ + "static/media/open-box.a34d293102c989f708cdd85337989fbe.svg";
export { ForwardRef as ReactComponent };